// Components==============
import { motion } from 'framer-motion';
import React from 'react';
import './index.module.scss';
// =========================

export default function Shade({ onClick }) {
    return (
        <motion.div
            animate={{ opacity: 0.7 }}
            initial={{ opacity: 0 }}
            styleName="shader"
            onClick={onClick}
        />
    );
}
